import Accordion from './accordion';
import FilterAccordion from './variants/filterAccordion';

export default Accordion;

export { FilterAccordion };
